import clsx from 'clsx'
import React from 'react'
import {useIntl} from 'react-intl'
import {convertUserTimeZone, KTSVG} from '../../../../../_gori/helpers'
import {UserModel} from '../../../auth'
import {InputTextArea, InputTextFormik, SelectFormik} from '../../../../../_gori/partials/widgets'
import {OPTION_ITEM_TYPE} from '../../../claims/core/_const'
import {ItemPackages} from '../ItemPackages'
import {Link, useParams} from 'react-router-dom'
import {isEmpty} from 'lodash'
import {ROUTES} from '../../../../../_gori/constants'
import A1_CONSTANTS from '../../../a1/core/_const'
import moment from 'moment'
import {FormikProps} from 'formik'

type Props = {
  className?: string
  isDisablePage: boolean
  showHide: boolean
  setShowHide: React.Dispatch<
    React.SetStateAction<{
      shipmentDetail: boolean
      custom: boolean
      orderDetail: boolean
    }>
  >
  currentUser: UserModel | undefined
  data: any
  isA1: boolean
  hasPermissionView: any
  handleAddNewItem: (name: any) => Promise<void>
  handleDeleteItem: (name: any, keyDelete: any) => Promise<void>
  formik: FormikProps<any>
}

const OrderDetail: React.FC<Props> = ({
  className,
  isDisablePage,
  showHide,
  setShowHide,
  currentUser,
  data,
  isA1,
  hasPermissionView,
  handleAddNewItem,
  handleDeleteItem,
  formik,
}) => {
  const intl = useIntl()
  const params = useParams()

  return (
    <div
      className={clsx(
        'bg-white rounded-2',
        {
          'bg-light cursor-no-drop': isDisablePage,
        },
        className
      )}
    >
      <div className='d-flex justify-content-between align-items-center p-6'>
        <span className='fs-2 fw-bolder'>{intl.formatMessage({id: 'ORDER_DETAIL'})}</span>
      </div>
      {((showHide && isDisablePage) || !isDisablePage) && (
        <div className='pb-6 px-6'>
          <hr className='bg-gray-600 mt-0 mb-6' />
          <div className='d-flex'>
            <div className='col-6 pe-6'>
              <label className={clsx('col-form-label', isDisablePage ? 'col-5' : 'col-4')}>
                {intl.formatMessage({id: 'ORDER_DATE'})}
              </label>
              <span className='col-8 text-dark fw-bolder'>
                {!params?.id
                  ? moment().format(process.env.REACT_APP_DATE_FORMAT)
                  : convertUserTimeZone(
                      data?.created_at,
                      currentUser,
                      process.env.REACT_APP_DATE_FORMAT
                    )}
              </span>
            </div>
            <div className='col-6 ps-6'>
              <label className='col-form-label col-4'>BAE ID</label>
              <span className='col-8 text-dark fw-bolder'>
                {data && (
                  <>
                    <span className='fw-bolder text-dark'>{data?.code}</span>
                  </>
                )}
              </span>
              {isA1 ? (
                <Link
                  to={`${ROUTES.A1.BASE}/${data?.a1_batch_id}?status=${A1_CONSTANTS.A1_BATCH_STATUS.OPEN}`}
                >
                  <KTSVG path='media/gori/a1/logo_order.svg' className='svg-icon-1' />
                </Link>
              ) : null}
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div className={clsx('col-6 pe-6', {'d-flex': !isDisablePage})}>
              <InputTextFormik
                className={clsx('col-8', {'col-12': isDisablePage})}
                labelClassName='col-4 col-form-label text-nowrap'
                label={intl.formatMessage({id: 'REF_1'})}
                name='reference1'
                formik={formik}
                disabled={hasPermissionView || isDisablePage}
              />
            </div>
            <div className={clsx('col-6 ps-6', {'d-flex': !isDisablePage})}>
              <InputTextFormik
                className={clsx('col-8', {'col-12': isDisablePage})}
                labelClassName='col-4 col-form-label text-nowrap'
                label={intl.formatMessage({id: 'REF_2'})}
                name='reference2'
                formik={formik}
                disabled={hasPermissionView || isDisablePage}
              />
            </div>
          </div>
          {!formik.values.international && formik.values.service?.startsWith('usps_') && (
            <div className='d-flex justify-content-between mt-4'>
              <div className={clsx('col-6 pe-6', {'d-flex': !isDisablePage})}>
                <InputTextFormik
                  className={clsx('col-8', {'col-12': isDisablePage})}
                  labelClassName='col-4 col-form-label text-nowrap'
                  label={intl.formatMessage({id: 'REF_3'})}
                  name='reference3'
                  formik={formik}
                  disabled={hasPermissionView || isDisablePage}
                />
              </div>
            </div>
          )}
          <div className={clsx('mt-4', {'d-flex': !isDisablePage})}>
            <SelectFormik
              className={clsx('col-8', {'col-12': isDisablePage})}
              labelClassName='col-4 col-form-label text-nowrap'
              label={intl.formatMessage({id: 'MERCHANDISE_CATEGORY'})}
              placeholder={intl.formatMessage(
                {id: 'SELECT_A_INPUT'},
                {input: intl.formatMessage({id: 'MERCHANDISE_CATEGORY'})}
              )}
              options={OPTION_ITEM_TYPE}
              formik={formik}
              name={'claim_category'}
              hasUseIntl={true}
              disabled={hasPermissionView || isDisablePage}
            />
          </div>
          <div className={clsx('mt-4', {'d-flex': !isDisablePage})}>
            <InputTextArea
              className={clsx('col-8 h210', {'col-12': isDisablePage})}
              labelClassName='col-4 col-form-label text-nowrap'
              label={intl.formatMessage({id: 'ORDER_NOTE'})}
              formik={formik}
              name='note'
              disabled={hasPermissionView || isDisablePage}
            />
          </div>
          <hr className='bg-gray-600' />
          <ItemPackages
            formik={formik}
            data={data}
            handleAddNewItem={handleAddNewItem}
            handleDeleteItem={handleDeleteItem}
            disabled={isDisablePage || hasPermissionView || !isEmpty(data?.store_order_id)}
          />
        </div>
      )}
    </div>
  )
}

export default OrderDetail
